import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';

@Injectable({
  providedIn: 'root'
})
export class BinnacleMeetingsService {

  private readonly url = environment.apiURL;
  constructor(
    private readonly _http: HttpClienteService,
  ) { }

  getBinnacleSave(data: any) {
    const query = `${this.url}/wcl-seller/binnacle-save`
    return this._http.post(query, data);
  }
  getBinnacleListGeneral(data: any) {
    const query = `${this.url}/wcl-seller/v2/binnacles-paginated-by-seller-email`;
    return this._http.post(query, data);
  }
  getBinnacleEdit(data: any) {
    const query = `${this.url}/wcl-seller/binnacle-update`
    return this._http.put(query, data);
  }
}